export default function Contact({ inputRef }) {
  return (
    <>
      <div
        className="mt-12 grid grid-cols-1 lg:grid-cols-2 w-full place-items-center"
        id="contact"
      >
        <div className="relative h-[300px] sm:h-[500px] w-full">
          <div className="w-[300px] h-[300px] relative lg:z-10 hidden lg:block">
            <img src="./assets/sammy.png" alt="" className="" />
          </div>
          {/* <div className="circle bg-[#f0f0f0] dark:bg-[#0D0E10] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2"></div> */}
          <div className="circle bg-[#26477c] bg-opacity-20 white top-1/2 -translate-y-[60%] left-1/2 -translate-x-[40%]"></div>

          <h1 className="absolute top-full text-center sm:top-[50%] -translate-y-[100%] left-1/2 -translate-x-[45%] w-60">
            Got a project?{" "}
            <a href="mailto:dahunsisamuel1st@gmail.com" className="underline">
              Let's Talk!
            </a>
          </h1>
        </div>

        <div className="contact-form mt-12 sm:mt-0">
          <div className="flex flex-col translate-y-[10%] sm:translate-y-[-10%] items-center w-full p-8 shadow">
            <h1 className="text-2xl sm:text-3xl font-extrabold md:mb-2 lg:mb-4">
              Contact Me
            </h1>

            <form
              action="https://getform.io/f/97787ab9-1538-4ec8-b49d-4e207ecf458e"
              method="POST"
              encType="multipart/form-data"
              target="_blank"
              onSubmit={(e) => console.log(e.target)}
            >
              <div className="flex m-4 flex-wrap gap-4 justify-center">
                <div className="shadow w-full sm:w-auto dark:bg-[#0d0e10]">
                  <input
                    ref={inputRef}
                    type="text"
                    className="p-2 w-full bg-[#f0f0f0] dark:text-[#0d0e10]"
                    name="name"
                    id="name"
                    placeholder="Your Name (required)"
                    required={true}
                  />
                </div>

                <div className="shadow w-full sm:w-auto dark:bg-[#0d0e10]">
                  <input
                    type="email"
                    className="p-2 w-full bg-[#f0f0f0] dark:text-[#0d0e10]"
                    name="email"
                    id="email"
                    placeholder="Your E-mail (required)"
                    required={true}
                  />
                </div>
              </div>

              <div className="shadow dark:bg-[#0d0e10] m-4">
                <textarea
                  name="message"
                  className="w-full p-2 bg-[#f0f0f0] dark:text-[#0d0e10] h-24 info"
                  id="message"
                  placeholder="Your Message"
                  rows="8"
                  required=""
                ></textarea>
              </div>

              <div className="w-max flex m-auto bg-[#0D0E10] rounded-full text-white dark:bg-white dark:text-[#0D0E10]">
                <input
                  type="submit"
                  className=" submit-btn w-24 p-2 mx-auto"
                  value="Send"
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="socials flex w-max mb-8 mt-20 sm:mt-4 mx-auto gap-4 sm:gap-8 lg:gap-12 justify-between">
        {[
          ["github-square", "https://github.com/psalmuel01"],
          ["google-plus-square", "mailto:dahunsisamuel1st@gmail.com"],
          ["linkedin-square", "https://linkedin.com/in/samuel-dahunsi"],
          ["twitter-square", "https://twitter.com/psalmuel1st"],
          ["whatsapp", "https://wa.link/b1sm6p"],
        ].map(([name, url]) => (
          <a href={url} key={name}>
            <i
              className={`fa fa-${name} text-4xl lg:text-5xl shadow-lg hover:shadow-xl trans duration-100 rounded p-1`}
            ></i>
          </a>
        ))}
      </div>
    </>
  );
}
